<template>
  <div class="select-container">
    <el-select
      v-model="val"
      :size="size"
      filterable
      remote
      :multiple="multiple"
      :reserve-keyword="reserveKeyword"
      :clearable="clearable"
      :placeholder="placeholder"
      :remote-method="remoteMethod"
      :loading="loading"
      :disabled="disabled"
      @change="handleChange"
      ref="select"
    >
      <el-option
        v-for="point in skill_points"
        :key="point.id"
        :label="point.name"
        :value="point.id"
      ></el-option>
    </el-select>
    <template v-if="showLevel && !multiple">
      <span> - </span>
      <el-select class="w-180" v-model="level" size="small" placeholder="水平">
        <el-option
          v-for="(val, key) in stack_options"
          :key="key"
          :label="val"
          :value="Number(key)"
        ></el-option>
      </el-select>
      <el-button type="primary" plain size="small" @click="handleAddStackTag"
        >添加技能</el-button
      >
    </template>
  </div>
</template>

<script>
import kcellService from "@/global/service/kcell";
// import skill_level_options from "./skill_level_options";

export default {
  props: {
    value: {
      type: [Number, Array, String],
      default: null
    },
    skills: {
      type: Array
    },
    size: {
      type: String,
      default: "mini"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    reserveKeyword: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "关联技能栈"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showLevel: {
      type: Boolean,
      default: false
    },
    showTag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: null,
      loading: false,
      skill_points: [],
      level: null
      // stack_options: skill_level_options
    };
  },
  created() {
    if (this.skills) this.skill_points = this.skills;
  },
  watch: {
    value(val) {
      this.val = val;
      if (!val) {
        this.skill_points = [];
      }
    },
    val(val) {
      this.$emit("update:value", val);
      if (!val) {
        this.skill_points = [];
      }
    },
    skill_points(val) {
      this.$emit("update:skills", val);
    }
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        kcellService
          .kcellSkills({ name: query })
          .then(res => {
            this.skill_points = res;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.skill_points = [];
      }
    },
    handleChange(e) {
      if (this.showTag) {
        const stack = this.skill_points.find(d => d.id === e);
        this.val = null;
        this.$emit("change", stack);
      } else {
        this.$emit("change", e);
      }
      this.$refs["select"].blur();
    },
    handleAddStackTag() {
      const stack_id = this.val;
      const level = this.level;
      if (!stack_id) return this.$message.error("请选择技能栈");
      if (!level && level !== 0) return this.$message.error("请选择技能栈水平");
      const stack = this.skill_points.find(d => d.id === stack_id);
      if (!stack) return this.$message.error("请重新选择");
      stack.level = level;
      this.$emit("add", stack);
      this.val = null;
      this.level = null;
    }
  }
};
</script>
<style lang="less" scoped>
.select-container {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
// example 使用
// 1.显示水平选项
// <SelectSkill
//   class="w-400"
//   size="small"
//   :value.sync="basicInfo.stackIds"
//   :skills.sync="basicInfo.stackList"
//   :disabled="isDisabled"
//   :show-level="true"
//   :multiple="false"
//   @add="handleAddStackTag"
// ></SelectSkill>
// 2.不显示水平选项
// <SelectSkill
//   class="w-400"
//   size="small"
//   :value.sync="basicInfo.stackIds"
//   :skills.sync="basicInfo.stackList"
//   :disabled="isDisabled"
//   :show-level="true"
//   :multiple="true"
//   @change="change"
// ></SelectSkill>
</style>
